﻿import { opaccFilterCriterias } from './opacc.class.filter-criterias.factory.js';

export class RangeFilter {
  constructor(item, wrapper) {    
    this.filterItem = item;
    this.wrapperItem = wrapper;
    if (this.wrapperItem) {
      let itemId = `#${this.filterItem.getAttribute('id')}`;
      this.sliderHandler = this.wrapperItem.querySelector(`${itemId}-slider`);
      this.sliderValues = [
        this.wrapperItem.querySelector(`${itemId}-from`),
        this.wrapperItem.querySelector(`${itemId}-to`)
      ];

      this.displaySliderValues = undefined;
      this.rangeSeparator = undefined;
      
      if (this.wrapperItem.querySelector(`${itemId}-combined-range`)) {
        this.displaySliderValues = [
          this.wrapperItem.querySelector(`${itemId}-combined-range .combined-from`),
          this.wrapperItem.querySelector(`${itemId}-combined-range .combined-to`)
        ];
        this.rangeSeparator = this.wrapperItem.querySelector(`${itemId}-combined-range .range-separator`);
      }
      
      if (this.sliderHandler) {
        this.sliderOptions = this.sliderHandler.dataset.opSliderOptions;
        this.createSlider();
      }
    }
  }
  
  createSlider() {
    window.rangeSlider.create(this.sliderHandler, JSON.parse(this.sliderOptions));
    this.updateSliderFields(this.sliderValues, this.sliderHandler, this.displaySliderValues, this.rangeSeparator);
  }
  
  updateSliderFields(sValues, sHandler, sDisplay, sSeparator) {
    this.sliderHandler.rangeSlider.on('update', function( values, handle ) {
      sValues[handle].value = values[handle];
      if (sDisplay) {
        sDisplay[handle].innerHTML = values[handle];
      }
      
      if (sSeparator) {
        const equals = sValues.every(function(field, index, sValues){
          return field.value === sValues[0].value;
        });
  
        if (equals) {
          sSeparator.classList.add('is-visuallyhidden');
          sDisplay[0].classList.add('is-visuallyhidden');
        } else {
          sSeparator.classList.remove('is-visuallyhidden');
          sDisplay[0].classList.remove('is-visuallyhidden');
        }
      }
    });

    this.sliderHandler.rangeSlider.on('change', function( values ) {
      let valueConcat = `[${values.join('|')}]`;
      opaccFilterCriterias.change(sHandler.dataset.opFilterattr, valueConcat);
    });
  }
}